import React from 'react';

import { Icon } from '@shared/ui';

import cls from './PlayVideoBtn.module.css';

export const PlayVideoBtn = () => (
    <span className={cls.PlayVideoBtn}>
        <Icon iconName="playVideo" />
    </span>
);
